import { useMemo } from "react";

import { Root } from "@clinic/emerson/routes/Root/Root";
import { GTMBody } from "@remix/components/GTMBody/GTMBody";
import { GoogleServices } from "@remix/components/GoogleServices/GoogleServices";
import { useSafeLoaderData } from "@remix/helpers/loaders/useSafeLoaderData";
import { useInitialProps } from "@shared/context/InitialPropsProvider";
import { isSSR } from "@shared/utils/fullscriptEnv/fullscriptEnv";

import { loader } from "./loader";
import { loaderSchema } from "./schema";

export default () => {
  const { initialProps, googleTagManager, ...staticData } = useSafeLoaderData(loaderSchema);
  const { flippers, isAdminImpersonating, roleId, userId } = useInitialProps();
  const { currentRole, currentUser } = initialProps ?? {};

  useMemo(() => {
    const isUserDataLoaded = currentUser && currentRole;

    if (!isSSR() && "CoralogixRum" in window && isUserDataLoaded) {
      window.CoralogixRum.setUserContext({
        user_id: userId,
        user_name: currentUser.fullName,
        user_metadata: {
          role_id: roleId,
          admin_impersonating: isAdminImpersonating,
          enabled_flippers: flippers,
        },
      });
    }
  }, []);

  return (
    <>
      <GoogleServices googleTagManager={googleTagManager} />
      <Root
        adminImpersonating={isAdminImpersonating}
        roleId={roleId ?? ""}
        storeId={currentRole?.storeId ?? ""}
        userId={userId ?? ""}
        {...staticData}
      />
      <GTMBody googleTagManager={googleTagManager} />
    </>
  );
};

export { loader };
